var React = require('react');

function WindowRestore (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 48v288a48 48 0 0 1-48 48h-48V176a80.11 80.11 0 0 0-80-80H128V48a48 48 0 0 1 48-48h288a48 48 0 0 1 48 48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M336 128H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V176a48 48 0 0 0-48-48zm-20 128H64v-52a12 12 0 0 1 12-12h228a12 12 0 0 1 12 12z","className":"fa-primary","key":2})]);
}

WindowRestore.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = WindowRestore;

WindowRestore.default = WindowRestore;
